"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemPipesByIdentifier = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../../utils/constants");
var _models = require("../../models");
var _functions = require("../../../utils/functions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ItemPipesByIdentifier = exports.ItemPipesByIdentifier = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    identifierTypeKey
  } = _ref;
  const isKey = (0, _functions.isSomeComponentTypeKey)(identifierTypeKey);
  const unknownKey = identifierTypeKey > 6;
  if (unknownKey || isKey([-1, _constants.htgHxConfig.throttleCircuit])) return null;
  const showSecondPipe = isKey([_constants.htgHxConfig.mixingCircuitWithFixedBypass, _constants.htgHxConfig.injectionCircuitWith3wayValve]);
  return /*#__PURE__*/_react.default.createElement("group", null, showSecondPipe && /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, _constants.verticalPipeSpacing, -28],
    scale: [1, 1, _constants.sizeOfStraightPipePerUnit * (_constants.verticalPipeSpacing + 0.25)],
    rotation: [Math.PI / 2, 0, 0],
    highlightsType: _constants.pipesTypes.heatingReturn
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, _constants.verticalPipeSpacing, -33],
    scale: [1, 1, _constants.sizeOfStraightPipePerUnit * (_constants.verticalPipeSpacing + 0.25)],
    rotation: [Math.PI / 2, 0, 0],
    highlightsType: _constants.pipesTypes.heatingReturn
  }));
}, function () {
  let prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return prev.identifierTypeKey === next.identifierTypeKey && prev.showBox === next.showBox;
});
ItemPipesByIdentifier.propTypes = {
  identifierTypeKey: _propTypes.default.number
};